export default __webpack_public_path__ + "static/media/md.3f337ddf.png";